import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";

import CTA from "../CTA/CTA";

import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import WorkOrderStackFeatures from "./WorkOrderStackFeatures";
import WorkOrderStackBenefits from "./WorkOrderStackBenefits";

const data1 = [
  "CM Work order: The CM (Contract Manufacturing) work order process allows sellers to initiate and manage production tasks with manufacturers. It includes tracking key project milestones, managing product specifications, and overseeing the production timeline. This system streamlines coordination between sellers and manufacturers, ensuring that projects meet deadlines and quality standards. ",
  "CF Work order: The CF (Contract Farming) work order system enables sellers to manage and monitor agricultural operations, such as apiary management in beekeeping. It tracks critical aspects like production timelines, resource allocation, health monitoring, and environmental conditions. This system ensures efficient farm management and smooth coordination between farmers and stakeholders.",
];
const data2 = [
  "IAM: IAM  validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",

  "DB: The database (db) stores configurations, device metadata, topics, and commands, serving as a central repository for managing crucial system information and facilitating efficient data retrieval and manipulation.",
];
// WorkOrderStack Component 

export default function WorkOrderStack() {
  return (
    <>
      {/* Section: Header Banner */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["Work Order Stack"]}
        bannerbodycopy="CF Work Order Management | CM Work Order Management"
      />

      {/* Section: Overview */}
      <SolutionEcosystem title="Overview" type="WO" />

      {/* Section: Feature Highlights */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Section: Additional Features */}
      <WorkOrderStackFeatures />

      {/* Section: Benefits */}
      <WorkOrderStackBenefits />

      {/* Section: Call to Action */}
      <Container className="subSectionWrapper">
        <CTA
          btnText="View APIs"
          href="/ComingSoon"
          heading="Do you want to develop applications or integrate your legacy hardware and software?"
        />
      </Container>
    </>
  );
}

